import { FC } from 'react'
import { Button } from '@mui/material'
import type { SxProps, Theme } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useIntl } from 'react-intl'
import { useLeaseContractsList } from 'services/contracts/hooks/useLeaseContracts'

interface CreateReservationProps {
  buttonSx?: SxProps<Theme>
  fullWidth?: boolean
}

// "+ Nowa rezerwacja" action button — opens the routed creation flow.
const CreateReservation: FC<CreateReservationProps> = ({ buttonSx, fullWidth }) => {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const { hasActiveLeases } = useLeaseContractsList()

  if (!hasActiveLeases) {
    return null
  }

  return (
    <Button
      data-cy='button-new-reservation'
      onClick={() => navigate('/common-room-reservations/create')}
      sx={buttonSx}
      fullWidth={fullWidth}>
      {formatMessage({
        id: 'helpdesk.newReservation',
        defaultMessage: '+ Nowa rezerwacja'
      })}
    </Button>
  )
}

export default CreateReservation
